module.exports = __webpack_public_path__ + "img/label002.1d952d32.jpg";